<template>
  <div class="profile-form">
    <form class="sa-form">
      <!-- eslint-disable vue/v-bind-style -->
      <div v-for="field in fields" v-bind:key="field.name" class="form-row">
        <div v-if="field.type === 'string'" class="form-group">
          <label>{{ field.label || field.name }}</label><br />
          <input
            v-model="user[field.name]"
            class="form-control"
          />
        </div>
        <div v-if="field.type === 'lineBreak'" class="lineBreak"></div>
      </div>
      <div class="form-row">
        <button
          class="btn my-4 waves-effect z-depth-0"
          type="submit"
          @click="save"
        >
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import AmplifyStore from '../store/store';
import { Auth } from 'aws-amplify'

export default {
  name: 'ProfileForm',
  //eslint-disable-next-line
  props: ['fields'],
  data () {
    return {
      user: {}
    }
  },

  async mounted () {
    if (AmplifyStore.state.user) {
      const currentUser = await Auth.currentUserInfo();
      this.user = {
        username: currentUser.username,
        ...currentUser.attributes
      }
    }
  },

  methods: {
    save() {
      const cognitoUser = AmplifyStore.state.user;
      if (!this.user || !cognitoUser) {
        return;
      }
      Auth.updateUserAttributes(cognitoUser, this.user).then((res) => {
        console.log(res);
      })
      .catch(e => console.log(e));
    }
  }
}
</script>
<style lang="scss">
@import "../styles/vendor/_bootstrap-setup";

.profile-form {
  .form-group {
    width: 100%;

    @include media-breakpoint-up(lg) {
      width: 50%;
    }
  }
}
</style>
